import React from 'react';
import type { EconomicBillingController } from './context';

/** Presentation only: neither a missing status nor a failed read selects legacy billing. */
export function EconomicBillingPending({ billing, onManage }: { billing: EconomicBillingController; onManage?: () => void }) {
  return <div className="space-y-1.5 text-xs">
    <div className="flex items-center gap-3"><div className="h-1 flex-1 rounded-full bg-raised" /><span className="font-semibold tabular-nums text-muted" aria-label="Capacidad aún no disponible">— %</span></div>
    <div className="flex flex-wrap justify-between gap-1 text-[11px] text-muted"><span>Renueva: —</span><span>Créditos: —</span></div>
    <button type="button" onClick={() => billing.error || !onManage ? void billing.refresh() : onManage()} className="min-h-9 rounded text-left text-xs font-semibold text-juris hover:underline">{billing.error ? 'Reintentar' : onManage ? 'Gestionar plan y créditos' : 'Actualizar'}</button>
  </div>;
}
